module.exports = __webpack_public_path__ + "media/src/images/step-01-e6fdc19a896fbda2321d8c7f9a9af768.svg";